import React from 'react';
import { pendingTasks } from 'types';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useRejectPendingTask from '../hooks/use-reject-pending-task';
import DialogForm from 'components/dialog/dialog-form';
import AppFormikInput from 'components/form/formik/input/input';

type TValues = {
    reason: string;
};

const DialogReject = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data: pendingTasks.TPendingTasks } & TDialogWrapperComponent) => {
    const [onRejectPendingTask, { isLoading }] =
        useRejectPendingTask(asyncStatesHandlers);

    const initValues: TValues = {
        reason: '',
    };

    return (
        <DialogForm<TValues>
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Reject pending task'}
            onSubmit={async (values) => {
                const payload = {
                    id: data.id,
                    ...values,
                };
                await onRejectPendingTask(payload);
            }}
            isLoading={isLoading}
            initValues={initValues}
            validate={(values) => {
                let errors: Partial<TValues> = {};

                if (values.reason.length === 0) {
                    errors.reason = 'Required';
                }

                return errors;
            }}
        >
            <AppFormikInput name={'reason'} placeholder={'Reject reason'} />
        </DialogForm>
    );
};

export default DialogReject;
